import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <>
      <div className="min-h-screen py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-lg p-8"
          >
            <h1 className="text-3xl font-bold text-gray-900 mb-6">אודות בית העסק</h1>
            <div className="prose max-w-none text-gray-600">
              <p>
                <strong>Printeam</strong> היא פעילות למיתוג, הדפסה והתאמה אישית של מוצרי
                טקסטיל ומוצרים ממותגים לעסקים, ארגונים, מוסדות ואירועים.
              </p>
              <p>
                הפעילות מופעלת על ידי <strong>א.ז. שירותי מחשוב ולוגיסטיקה</strong>, ומציעה
                שירותי ייצור, מיתוג, הדפסה והתאמה אישית בהתאם למפרטי ההזמנה המאושרים על ידי
                הלקוח.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">מה אנחנו עושים</h2>
              <p>
                אנו מספקים הזמנות של פריטי לבוש ומוצרים ממותגים עם אפשרויות התאמה אישית,
                לרבות בחירת מוצר, צבע, מידה, מיקום מיתוג, קבצי גרפיקה ושיטת מיתוג, בהתאם
                למידע שמוצג באתר ובתהליך ההזמנה.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">פרטי בית העסק</h2>
              <p>
                שם העסק: <strong>Printeam</strong>
              </p>
              <p>
                מפעיל: <strong>א.ז. שירותי מחשוב ולוגיסטיקה</strong>
              </p>
              <p>
                כתובת: האורגים 32, חולון
              </p>
              <p>
                טלפון: <a href="tel:+972503969640" className="text-blue-600 hover:underline">050-396-9640</a>
              </p>
              <p>
                אימייל: <a href="mailto:info@printeam.co.il" className="text-blue-600 hover:underline">info@printeam.co.il</a>
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">יצירת קשר</h2>
              <p>
                ניתן ליצור קשר עם בית העסק דרך דף <a href="/contact" className="text-blue-600 hover:underline">צור קשר</a>,
                בטלפון, בוואטסאפ או בדואר אלקטרוני, בהתאם לפרטים המופיעים באתר.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default About;
